import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import axios from '../../utils/axios';

export const getCredits = createAsyncThunk('credits/getCredits', async () => {
  const response = await axios.get('/selled_credits/');
  return response.data;
});

export const addCredits = createAsyncThunk('addCredits', async (data, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.post('/selled_credits/', data);
    dispatch(getCredits());
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const listBalance = createAsyncThunk('listBalance', async (params) => {
  const response = await axios.get('/wallet/', { params });
  return response.data;
});

export const listBalanceByProviders = createAsyncThunk('listBalanceByProviders', async (params) => {
  const response = await axios.get('/wallet/', { params });
  return response.data;
});

const creditSlice = createSlice({
  name: 'credit',
  initialState: {
    credits: [],
    balance: [],
    balanceByProvider: [],
    isLoading: false,
    loading: false,
    isSubmitting: false,
  },
  reducers: {},
  extraReducers: {
    [getCredits.pending]: (state) => {
      state.loading = true;
    },
    [getCredits.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.credits = data;
      state.loading = false;
    },
    [getCredits.rejected]: (state) => {
      state.loading = false;
    },
    // ----------------------------
    [listBalance.pending]: (state) => {
      state.loading = true;
    },
    // ----------------------------
    [listBalance.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.balance = data;
      state.loading = false;
    },
    // ----------------------------
    [listBalance.rejected]: (state) => {
      state.loading = false;
    },
    // ----------------------------
    [addCredits.pending]: (state) => {
      state.isSubmitting = true;
    },
    [addCredits.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [addCredits.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ----------------------------
    [listBalanceByProviders.pending]: (state) => {
      state.loading = true;
    },
    // ----------------------------
    [listBalanceByProviders.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.balanceByProvider = data;
      state.loading = false;
    },
    // ----------------------------
    [listBalanceByProviders.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export const {} = creditSlice.actions;

export default creditSlice.reducer;
